module.exports = __webpack_public_path__ + "img/iconDeviceClose.c96283b0.svg";